import { AuthGlobal } from "../pages/remittance-beta/types/auth";

const STORAGE_KEYS = {
  userKey: "userKey",
  userToken: "userToken",
  currentUser: "currentUser",
  userEmail: "userEmail",
  userRole: "userRole",
  everestPartner: "everestPartner",
  isMasterVendor: "isMasterVendor",
  lanMandatory: "lanMandatory",
  lanLength: "lanLength",
  masterVendorName: "masterVendorName",
} as const;

export type AuthSession = Pick<
  AuthGlobal,
  | "userKey"
  | "userToken"
  | "currentUser"
  | "userEmail"
  | "userRole"
  | "everestPartner"
  | "isMasterVendor"
  | "lanMandatory"
  | "lanLength"
  | "masterVendorName"
>;

const parseJson = <T>(value: string | null, fallback: T): T => {
  if (!value) return fallback;
  try {
    return JSON.parse(value) as T;
  } catch {
    return fallback;
  }
};

export const authStorage = {
  getSession(): AuthSession {
    return {
      userKey: localStorage.getItem(STORAGE_KEYS.userKey) || "",
      userToken: localStorage.getItem(STORAGE_KEYS.userToken) || "",
      currentUser: parseJson(localStorage.getItem(STORAGE_KEYS.currentUser), null),
      userEmail: localStorage.getItem(STORAGE_KEYS.userEmail) || "",
      userRole: localStorage.getItem(STORAGE_KEYS.userRole) || "",
      everestPartner: localStorage.getItem(STORAGE_KEYS.everestPartner) === "true",
      isMasterVendor: localStorage.getItem(STORAGE_KEYS.isMasterVendor) === "true",
      lanMandatory: localStorage.getItem(STORAGE_KEYS.lanMandatory) === "true",
      lanLength: parseJson(localStorage.getItem(STORAGE_KEYS.lanLength), null),
      masterVendorName: localStorage.getItem(STORAGE_KEYS.masterVendorName) || "",
    };
  },

  setSession(session: Partial<AuthSession>) {
    if (session.userKey !== undefined) {
      localStorage.setItem(STORAGE_KEYS.userKey, session.userKey);
    }
    if (session.userToken !== undefined) {
      localStorage.setItem(STORAGE_KEYS.userToken, session.userToken);
    }
    if (session.currentUser !== undefined) {
      localStorage.setItem(STORAGE_KEYS.currentUser, JSON.stringify(session.currentUser));
    }
    if (session.userEmail !== undefined) {
      localStorage.setItem(STORAGE_KEYS.userEmail, session.userEmail);
    }
    if (session.userRole !== undefined) {
      localStorage.setItem(STORAGE_KEYS.userRole, session.userRole);
    }
    if (session.everestPartner !== undefined) {
      localStorage.setItem(STORAGE_KEYS.everestPartner, String(session.everestPartner));
    }
    if (session.isMasterVendor !== undefined) {
      localStorage.setItem(STORAGE_KEYS.isMasterVendor, String(session.isMasterVendor));
    }
    if (session.lanMandatory !== undefined) {
      localStorage.setItem(STORAGE_KEYS.lanMandatory, String(session.lanMandatory));
    }
    if (session.lanLength !== undefined) {
      localStorage.setItem(STORAGE_KEYS.lanLength, JSON.stringify(session.lanLength));
    }
    if (session.masterVendorName !== undefined) {
      localStorage.setItem(STORAGE_KEYS.masterVendorName, session.masterVendorName);
    }
  },

  clearSession() {
    Object.values(STORAGE_KEYS).forEach((key) => localStorage.removeItem(key));
  },

  hasValidTokens() {
    const { userKey, userToken } = authStorage.getSession();
    return Boolean(userKey && userToken);
  },
};

export default authStorage;
